import { defineDepKeys, pickDeps } from "./depTools";

const DASHBOARD_DEPS_KEYS = defineDepKeys([
  "useDisplayedAppVersion",
  "useSync",
  "VISIBLE_MODULES",
  "canViewModule",
  "normalizeUiPreferences",
  "makeSeed",
  "useFarmCollection",
  "useGlobalCollection",
  "normalizeAdminGlobalsConfig",
  "getDeviceId",
  "createClientId",
  "NOTIFICATIONS_DEVICE_URL",
  "API_SECRET",
  "MAPS_PLATFORM",
  "normalizeServiceType",
  "itemMatchesCostCenterAccess",
  "canViewCostCenter",
  "warmUsageBaseModuleKey",
  "MODULE_PRIORITY_WARM_PLAN",
  "trackContextualWarmUsage",
  "recordSessionWarmNavigation",
  "getSessionWarmCandidates",
  "runControlledPriorityWarm",
  "getWarmControlDeps",
  "trackWarmUsage",
  "getPriorityConfig",
  "getEditableServiceStatuses",
  "SHORTCUT_MODULE_CHOICES",
  "getContrastTextColor",
  "syncFarmCollaboratorAccountsToEmployees",
  "MODULES",
  "SVC_STATUS_FLOW",
  "ModuleHeaderMenu",
  "ServicePhotosModal",
  "ServicePhotoStatusIcon",
  "ServicePhotoAddPhoneIcon",
  "ServiceDetailModal",
  "ServiceDenyModal",
  "PauseTaskModal",
  "NFModal",
  "MaterialsModal",
  "ColActionButtons",
  "OccurrencesModule",
  "SystemListsManager",
  "ServicesModule",
  "roleColor",
  "isFarmArchived",
  "PurchasesHubModule",
  "AnimalsModule",
  "AvicultureModule",
  "ClimateModule",
  "FinancialModule",
  "HRModule",
  "EquipamentosEPIsModule",
  "VetModule",
  "StockModule",
  "MachineryModule",
  "HarasModule",
  "LocationHubModule",
  "SedeModule",
  "InspectionsModule",
  "MeuPerfilModule",
  "ShortcutMonoIcon",
  "getShortcutChoiceMeta",
  "getFarmEmojiConfig",
  "FarmEmoji",
  "SyncStatusBar",
  "Modal",
  "Badge",
  "Btn",
  "fmtDate",
  "LIGHT_THEME",
  "T",
]);

function buildFarmDashboardDeps(deps) {
  return pickDeps(deps, DASHBOARD_DEPS_KEYS);
}

export { DASHBOARD_DEPS_KEYS, buildFarmDashboardDeps };
